import Vue from "vue";
import gaService from "./ga.service";

export default {
    async getGamesAsync() {
        return (await Vue.http.get("/api/aviatrix/games")).data;
    },
    async openSession(options = { lang: "en", game }) {
        const gameId = "Aviatrix";
        gaService.send("games", "aviatrix", gameId);
        return (await Vue.http.post("/api/aviatrix/session/open", Object.assign({}, options))).data;
    },
    async openDemoSession(options = { lang: "en", game }) {
        const gameId = "Aviatrix";
        gaService.send("games", "aviatrix", gameId);
        return (await Vue.http.post("/api/aviatrix/session/opendemo", Object.assign({}, options))).data;
    },
    async closeSession() {
        return (await Vue.http.post("/api/aviatrix/session/close")).data;
    }
};


// WEBPACK FOOTER //
// ./_common/services/aviatrix.service.js